import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const SortAsc = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="sort ascending icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C1.79086 0 0 1.79086 0 4L0 20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0L4 0ZM8.5 20C9.32843 20 10 19.3284 10 18.5V5.50004C10 4.89335 9.63454 4.3464 9.07403 4.11422C8.51351 3.88205 7.86834 4.01039 7.43934 4.43938L3.43934 8.43937C2.85355 9.02516 2.85355 9.9749 3.43934 10.5607C4.02513 11.1465 4.97487 11.1465 5.56066 10.5607L7 9.12135V18.5C7 19.3284 7.67157 20 8.5 20ZM13.5 5C12.6716 5 12 5.67157 12 6.5C12 7.32843 12.6716 8 13.5 8H19.5C20.3284 8 21 7.32843 21 6.5C21 5.67157 20.3284 5 19.5 5H13.5ZM12 12C12 11.1716 12.6716 10.5 13.5 10.5H16.5C17.3284 10.5 18 11.1716 18 12C18 12.8284 17.3284 13.5 16.5 13.5H13.5C12.6716 13.5 12 12.8284 12 12ZM15 17.5C15 18.3284 14.3284 19 13.5 19C12.6716 19 12 18.3284 12 17.5C12 16.6716 12.6716 16 13.5 16C14.3284 16 15 16.6716 15 17.5Z"
    />
  </svg>
)
